import React from "react";
import StoreOption from "./Store/StoreOption";

const StoreSwitch = (props) => {
    const {
        id,
        isActive,
        onSelect,
        className = "",
        ...rest
    } = props;

    return (
        <li key={id}>
            <button
                type="button"
                role="option"
                aria-selected={isActive}
                onClick={() => onSelect?.()}
                className={
                    "w-full text-left p-1 flex items-start gap-3 hover:bg-neutrals-800 focus:bg-neutrals-800 focus:outline-none " +
                    (isActive ? "bg-neutrals-900 " : "") + className
                }
            >
                <StoreOption {...rest} />
            </button>
        </li>
    );
};

export default StoreSwitch;
